<template>
    <div>
        <div class="card-header w-100 d-flex align-items-center">
            <h3 class="card-title">Sectores del recinto</h3>
            <div class="ml-auto">
                <Button class="mr-2" @click="volver()">Seleccionar otra región</Button>
                <Button @click.prevent="guardarPreciosSectores(sectores)">Guardar todos</Button>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <ContentOrLoading :style="loading ? 'padding: 50px;' : ''">
                        <div v-if="entradas && sectores && sectores.length > 0">
                            <div v-for="(sector, index) in sectores" class="row mb-4" :key="index">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 col-md-2">
                                            <strong>{{ sector.name }}</strong>
                                        </div>
                                        <div class="col-12 col-md-4 mt-2 mt-md-0" :id="'taquilla-' + sector.id">
                                            <div>
                                                <label for="precio_taquilla" v-if="index === 0">Precio Taquilla:</label>
                                            </div>
                                            <multiselect v-model="sector.precios_taquilla" placeholder="Precios taquilla"
                                                         track-by="id" :custom-label="labelTaquilla" :options="entradas"
                                                         :multiple="true" :max-height="150"
                                            />
                                        </div>
                                        <div class="col-12 col-md-4 mt-2 mt-md-0" :id="'online-' + sector.id">
                                            <div>
                                                <label for="precios_online" v-if="index === 0">Precios Online:</label>
                                            </div>
                                            <multiselect v-model="sector.precios_online" placeholder="Precios online"
                                                         track-by="id" :custom-label="labelOnline" :options="entradas"
                                                         :multiple="true" :max-height="150"
                                            />
                                        </div>
                                        <div class="col-12 col-md-2 my-auto pt-0 pt-md-4">
                                            <Button @click.prevent="guardarPreciosSectores([sector])" :id="'btn-' + sector.id" class="btn-block mt-2 mt-md-0">
                                                Guardar
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <h3>Este recinto no tiene sectores</h3>
                        </div>
                    </ContentOrLoading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['entradas', 'recinto_id', 'region_id'],
        data() {
            return {
                loading: false,
                sectores: null
            }
        },
        methods: {
            labelTaquilla({
                description,
                price,
                price_management_taquilla_interno,
                price_management_taquilla,
                descripcion,
                precio,
                dia_abonado,
                acompanante_abonado,
                amigo_abonado
            }) {
                description = description ?? descripcion;
                price = price ?? precio;
                var total = parseFloat(price) + price_management_taquilla;

                let abonadoLabel = '';
                if (dia_abonado) {
                    abonadoLabel = ' - Día de abonado';
                } else if (acompanante_abonado) {
                    abonadoLabel = ' - Acompañante de abonado';
                } else if (amigo_abonado) {
                    abonadoLabel = ' - Amigo de abonado';
                }

                if (price_management_taquilla_interno == 1) {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(price).toFixed(2) +
                        '€' +
                        ')'
                    );
                } else {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    );
                }
            },
            labelOnline({
                description,
                price,
                price_management_online_interno,
                price_management_online,
                descripcion,
                precio,
                dia_abonado,
                acompanante_abonado,
                amigo_abonado
            }) {
                description = description ?? descripcion;
                price = price ?? precio;
                var total = parseFloat(price) + price_management_online;

                let abonadoLabel = '';
                if (dia_abonado) {
                    abonadoLabel = ' - Día de abonado';
                } else if (acompanante_abonado) {
                    abonadoLabel = ' - Acompañante de abonado';
                } else if (amigo_abonado) {
                    abonadoLabel = ' - Amigo de abonado';
                }

                if (price_management_online_interno == 1) {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(price).toFixed(2) +
                        '€' +
                        ')'
                    );
                } else {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    );
                }
            },
            guardarPreciosSectores(sectores) {
                this.loading = true;
                let confSectores = JSON.parse(JSON.stringify(sectores));

                confSectores.map(sector => {
                    sector.precios_taquilla = sector.precios_taquilla.map(precio => precio.id);
                    sector.precios_online = sector.precios_online.map(precio => precio.id);
                });

                let params = {
                    filters: {},
                    data: confSectores,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                }

                if (this.region_id) {
                    params.filters.region_id = this.region_id;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.butacas.guardar-precios-sectores'), params)
                    .then(() => {
                        this.$emit('recargar', null, 'porSectores');
                        this.$toast.success('Precios guardados correctamente!');
                    }).catch(() => {
                        this.$toast.error('Ha ocurrido un error al guardar los precios')
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            getSectores() {
                this.loading = true;

                const params = {
                    filters: {},
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    recinto_id: this.recinto_id
                }

                let url = '';
                if (this.region_id) {
                    params.region_id = this.region_id;
                    url = 'back.events.sesiones.settings.zona.sectores';
                } else {
                    url = 'back.events.sesiones.settings.sectores';
                }

                this.$store.dispatch(this.config.getVuexAlias(url), params).then(res => {
                    this.sectores = res.data.data;
                }).catch(() => {
                    console.warn('Error al recuperar las butacas de la sesión');
                }).finally(() => {
                    this.loading = false;
                });
            },
            volver() {
                this.sectores = null,
                this.$emit('volver');
            }
        },
        created() {
            this.getSectores();
        }
    }
</script>